"use strict";

var _classCallCheck = require("C:\\Users\\muham\\Desktop\\iola_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\muham\\Desktop\\iola_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _require = require("./serialization"),
    produceXMLSerialization = _require.produceXMLSerialization;

exports.implementation = /*#__PURE__*/function () {
  function XMLSerializerImpl() {
    _classCallCheck(this, XMLSerializerImpl);
  }

  _createClass(XMLSerializerImpl, [{
    key: "serializeToString",
    value: function serializeToString(root) {
      return produceXMLSerialization(root, false);
    }
  }]);

  return XMLSerializerImpl;
}();